import { z } from 'zod'

/**
 * How deep qs must parse a search query string.
 *
 * Driven by the deepest shape any product puts in a URL: car hire's
 * `pickUpLocation[vendorDesks][0][openingTimes][0][hours][0]` is six bracket levels, one past qs's
 * default of 5. Over the limit qs does not throw - it stops descending and keeps the remainder as a
 * literal key, so `hours` arrives as `{ '[0]': '05:00-23:59' }` and fails schema validation as
 * "expected array, received object", an error that points at the schema when the fault is in the
 * parse.
 */
export const QUERY_PARAMS_PARSE_DEPTH = 7

export const QUERY_PARAMS_PARSE_OPTIONS = {
  depth: QUERY_PARAMS_PARSE_DEPTH,
  strictDepth: true,
} as const

export const DatesSchema = z.object({
  startDateTime: z.string(),
  endDateTime: z.string(),
})

export const SortingSchema = z
  .object({
    sortBy: z.string().optional(),
    orderBy: z.string().optional(),
  })
  .optional()

export const PriceRangeQuerySchema = z.preprocess((value: unknown) => {
  if (Array.isArray(value)) {
    return value.join(',')
  }
  return value
}, z.string())

export const ParamsSchema = z.object({
  dates: DatesSchema,
  sorting: SortingSchema,
  page: z.coerce.number().default(1),
})
